<template>
  <tr @click="onclick"
      :class="{ bgRow: row.data.iAmHighlited }">
    <table-cell
      v-for="column in visibleColumns"
      :row="row"
      :column="column"
      :key="column.id"
    ></table-cell>
  </tr>
</template>

<script>
import TableCell from './TableCell';

export default {
  props: {
    columns: {
      type: Array,
      required: true
    },
    row: {
      type: Object,
      required: true
    },
    highlightOnClick: false,
    iAmHighlited: false
  },

  components: {
    TableCell
  },

  methods: {

    onclick () {
      this.$emit('rowClick', this.row);
    }
  },

  computed: {
    visibleColumns () {
      return this.columns.filter(column => !column.hidden);
    }
  }
};
</script>

<style lang="scss">

.bgRow {
  background-color: #f05647;
}

</style>



// WEBPACK FOOTER //
// src/components/shared/table/components/TableRow.vue